import React from 'react';
import icCheckNot1 from 'Assets/img/sign/ic_check_not.png';
import icCheckNot2 from 'Assets/img/sign/ic_check_not@2x.png';
import icCheckNot3 from 'Assets/img/sign/ic_check_not@3x.png';
import icCheckBlue1 from 'Assets/img/sign/ic_check_blue.png';
import icCheckBlue2 from 'Assets/img/sign/ic_check_blue@2x.png';
import icCheckBlue3 from 'Assets/img/sign/ic_check_blue@3x.png';
import icArrow1 from 'Assets/img/ic_arrow_right_16.png';
import icArrow2 from 'Assets/img/ic_arrow_right_16@2x.png';
import icArrow3 from 'Assets/img/ic_arrow_right_16@3x.png';
import { getImageSet } from 'Util/DataUtils';
import IntlMessages from 'Util/IntlMessages';

const icCheckNot = getImageSet([icCheckNot1, icCheckNot2, icCheckNot3]);
const icArrow = getImageSet([icArrow1, icArrow2, icArrow3]);
const icCheckBlue = getImageSet([icCheckBlue1, icCheckBlue2, icCheckBlue3]);

const CheckBox = ({ label, isChecked, onSetIsChecked, onClickExtra, isError = false, errorText }) => {
  return (
    <>
      <div className="check-wrapper">
        <div className="check-main" onClick={() => onSetIsChecked(x => !x)}>
          <div style={{ cursor: 'pointer' }}>
            <img {...(isChecked ? icCheckBlue : icCheckNot)} alt="check" style={{ width: '20px', height: '20px' }} />
          </div>
          <div style={{ cursor: 'pointer' }} className="check-label">
            <IntlMessages id={label} />
          </div>
        </div>
        {onClickExtra && (
          <div className="check-extra" onClick={onClickExtra}>
            <img {...icArrow} alt="arrow" />
          </div>
        )}
      </div>
      {isError && errorText && (
        <div className="error-text" style={{ marginTop: '-32px' }}>
          {errorText}
        </div>
      )}
    </>
  );
};

export default CheckBox;
